import React from 'react';
import styles from './HorizontalScroller.module.css';

export const HorizontalScroller = ({ children }) => {
  return (
    <div className={styles.horizontalScroller}>
      <div className={styles.childrenContainer}>{ children }</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/HorizontalScroller/HorizontalScroller.jsx